module.exports = __webpack_public_path__ + "static/media/icon-quicklink-referral.1134ed12.svg";